module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_ce/6341/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/_function-to-string.js
// module id = 134
// module chunks = 0